import React from 'react';
import RelatorioPesquisas  from '../components/Relatorio_Pesquisas';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const Pesquisas = () => {
  
  return (
    <div className="content-wrapper">
      <h3>Pesquisas de Clientes</h3>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Incio</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Pesquisas</Breadcrumb.Item>
        </Breadcrumb>
      <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RelatorioPesquisas />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RelatorioPesquisas />
        </Col>
      </Row>
    </div>
  );
};

export default Pesquisas;